module.exports = __webpack_public_path__ + "img/question.b7bad90e.svg";